import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

function checkKeysAreNotChanged<T extends object>(a: T, b: T, keys?: (keyof T)[]): boolean {
  if ((!a || !b || !keys) && Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  let keysToCompare: (keyof T)[];
  if (!keys) {
    keysToCompare = Object.keys(a) as (keyof T)[];
  } else {
    keysToCompare = keys;
  }
  for (const key of keysToCompare) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}

// TODO: tests!!!
/**
 * Extended distinctUntilChanged operator.
 * @param keys - Array of entity keys to distinct. If not provided, will check all keys. Uses shallow comparison.
 */
export function distinctUntilKeysChanged<T extends object>(keys?: (keyof T)[]): MonoTypeOperatorFunction<T> {
  return (input$): Observable<T> =>
    input$.pipe(
      distinctUntilChanged((a, b) => {
        if (typeof keys === 'undefined') {
          return checkKeysAreNotChanged(a, b);
        }
        return checkKeysAreNotChanged(a, b, keys);
      }),
    );
}
